import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from 'src/app/components/auth/service/auth.service';
import { SharedDataService } from '../shared-service/shared-data.service';
import * as moment from 'moment-timezone';
import { SocketService } from '../socket-service/socket-service.service';
import { PermissionService } from '../permission-access-service/permissionBased.service';
import { firstValueFrom } from 'rxjs';

export const AuthGuard: CanActivateFn = async (route, state) => {
  const router = inject(Router);
  const authService = inject(AuthService);
  const sharedDataService = inject(SharedDataService);
  const socket = inject(SocketService);
  const permissionService = inject(PermissionService);

  const doLogout = () => {
    sharedDataService.saveUser(null);
    permissionService.setUser({});
    socket.disconnectSocket();
    authService.removeToken('access_token');
    authService.removeToken('refresh_token');
    router.navigate(['/login']);
  };

  try {
    const data = await firstValueFrom(authService.me());
    if (data && data.user && data.user.role.type === 'fundingsource') {
      sharedDataService.saveUser(data.user);
      permissionService.setUser(data.user);
      socket.connectSocket();
      moment.tz.setDefault(data.user.timeZone);
      return true;
    } else {
      doLogout();
      return false;
    }
  } catch (err) {
    doLogout();
    return false;
  }
};
